import React, {FC, useState} from 'react';
import {createStyles, NativeSelect, PasswordInput, SelectItem, TextInput} from '@mantine/core';

const useStyles = createStyles((theme, {floating}: { floating: boolean }) => ({
  root: {
    position: 'relative',
  },

  label: {
    position: 'absolute',
    zIndex: 2,
    top: 7,
    left: theme.spacing.sm,
    pointerEvents: 'none',
    color: floating
      ? theme.colorScheme === 'light'
        ? theme.colors.gray[5]
        : theme.white
      : theme.colorScheme === 'dark'
        ? theme.colors.dark[3]
        : theme.colors.gray[5],
    transition: 'transform 150ms ease, color 150ms ease, font-size 150ms ease',
    transform: floating ? `translate(-${theme.spacing.sm}px, -28px)` : 'none',
    fontSize: floating ? theme.fontSizes.xs : theme.fontSizes.sm,
    fontWeight: floating ? 700 : 500,
  },

  required: {
    transition: 'opacity 150ms ease',
    opacity: floating ? 1 : 0,
  },

  input: {
    '&::placeholder': {
      transition: 'color 150ms ease',
      color: !floating ? 'transparent' : undefined,
    },
  },
}));

type Props = {
  label: string;
  placeholder?: string;
  onChange: (value: string) => void;
  error?: React.ReactNode;
  required?: boolean;
  defaultValue?: string;
  name?: string;
}

type PropsSelect = {
  data: (string | SelectItem)[]
  label: string;
  required?: boolean;
  onChange: (value: any) => void;
}


export const CustomInput = ({label,placeholder, required, onChange, defaultValue, name, error, ...props}: Props) => {
  const ref = React.useRef<HTMLInputElement>(null);
  const [focused, setFocused] = useState(false);
  const [value, setValue] = useState('');
  const {classes} = useStyles({floating: value.trim().length !== 0 || focused});

  return (
    <TextInput
      {...props}
      label={label}
      placeholder={placeholder}
      required={required}
      classNames={!placeholder ? classes : undefined}
      value={value}
      onChange={(event) => {
        setValue(event.currentTarget.value);
        onChange(event.currentTarget.value)
      }}
      ref={ref}
      error={error}
      defaultValue={defaultValue}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      mt={!placeholder ? 'md' : 'o'}
      autoComplete="nope"
      name={name}
    />
  );
}

export const CustomInputPassword: FC<Props> = ({label, required, onChange, error}) => {
  const [focused, setFocused] = useState(false);
  const [value, setValue] = useState('');
  const {classes} = useStyles({floating: value.trim().length !== 0 || focused});

  return (
    <PasswordInput
      label={label}
      required={required}
      classNames={classes}
      value={value}
      error={error}
      onChange={(event) => {
        setValue(event.currentTarget.value);
        onChange(event.currentTarget.value)
      }}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      mt="md"
      autoComplete="nope"
    />
  );
}

export const CustomInputSelect: FC<PropsSelect> = ({label, required, onChange, data}) => {
  const [focused, setFocused] = useState(false);
  const [value, setValue] = useState('');
  const {classes} = useStyles({floating: value.trim().length !== 0 || focused});

  return (
    <NativeSelect
      label={label}
      required={required}
      classNames={classes}
      data={data}
      value={value}
      onChange={(event) => {
        setValue(event.currentTarget.value);
        onChange(event.currentTarget.value)
      }}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      mt="md"
      autoComplete="nope"
    />
  );
}